const fieldOptionsConfig = require("../config/fieldOptionsConfig.js");
const fieldsConfig = require("../config/fields/index.js");

const $inject = [];
const settingsService = function () {

  const service = {
    settings: undefined,
    options: undefined,
    get
  };

  function get() {
    service.options = fieldOptionsConfig;
    return fieldsConfig;
  }

  return service;
};

settingsService.$inject = $inject;

export default settingsService;


// WEBPACK FOOTER //
// ./src/services/settingsService.js